import { initialState } from "../initialState";
import * as ReasonActions from "./reasonActions";

export const reasonReducer = (state = initialState.reasons, action) => {
    switch (action.type) {
        case ReasonActions.REQUEST_REASONS:
            return { ...state };

        case ReasonActions.REQUEST_REASONS_SUCCEEDED:
            return { ...state, partialReasons: action.payload };

        case ReasonActions.REQUEST_REASONS_FAILED:
            return { ...state, partialReasons: initialState.reasons.partialReasons };

        case ReasonActions.REQUEST_COMPLETE_REASONS:
            return { ...state };

        case ReasonActions.REQUEST_COMPLETE_REASONS_SUCCEEDED:
            return { ...state, completeCodeReasons: action.payload };

        case ReasonActions.REQUEST_COMPLETE_REASONS_FAILED:
            return { ...state, completeCodeReasons: initialState.reasons.completeCodeReasons };
        default:
            return state;
    }
};
